export const approveInWalletLiteral = "Approve the transaction in your wallet.";
